import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tr-form-group-footer',
  templateUrl: './form-group-footer.component.html',
  //styleUrls: ['./form-group-footer.component.scss']
})
export class FormGroupFooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/form/form-group-footer/form-group-footer.component.ts